import api from 'app/api';
import store from 'app/store';
import { ALL_CITIES_FILTER } from './constants';

export const getEventList = async (params, callback) => {
  const {
    searchText,
    page_no,
    page_size,
    city,
    status,
  } = params;

  const successCallback = ({ data, pagination }) => {
    const eventList = (data || []).map((item) => ({
      ...item,
      ...item?.payload,
    }));
    store.dispatch({ type: 'ADMIN_EVENT_LIST:DATA:SET', data: { data: eventList, totalPages: pagination?.total_pages || 1 } });

    if (callback) callback(data);
  };

  await api.post(
    `/events/list/secondary`,
    {
      page_no: page_no ? (page_no - 1) : 0,
      page_size: page_size || 10,
      searchText: searchText,
      city: city,
      status: status,
    },
    {
      id: 'list-event',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

export const deleteEvent = async (id, isDraft, callback) => {
  const successCallback = ({ data }) => {
    if (callback) callback(data);
  };

  await api.delete(
    `/events/${id}`,
    {
      id: 'delete',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params: {
        isDraft,
      },
    },
  );
};

export const getCitiesList = async (callback) => {
  const successCallback = ({ data }) => {
    const cityList = (data || []).map((item) => ({ ...item, id: item?.cityName, label: item?.cityName }));
    store.dispatch({ type: 'ADMIN_EVENT_LIST:CITY_LIST:SET', data: ALL_CITIES_FILTER.concat(cityList) });

    if (callback) callback(data);
  };

  await api.get(
    `/venues/city`,
    {
      id: 'list-cities',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params: {
        isAdmin: true,
      },
    },
  );
};
